var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBandcamp2 = function SvgBandcamp2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.873L6.805 0H22l-7.018 12.873z",
    fill: "#1DA0C3",
    fillRule: "nonzero"
  })));
};
export default SvgBandcamp2;